import 'styles/application.scss';
import React from 'react';

import BaseLayout from './Base';
import AdminPanel from './AdminPanel';
import SiteAnnouncements from 'components/SiteAnnouncements';
import Notifications from 'components/Notifications';
import Modal from './Modal';
import Header from './Header';
import Footer from './Footer';
import * as Core from 'components/core';
import RenderError from 'components/RenderError';
import * as errorReporter from 'app/errorReporter';
import { cn } from '@/react-ui';

type Props = {
  children: React.ReactNode;
  sessionInitFailedMessage?: React.ReactNode | null;
  contentClassName?: string;
};

type State = {
  encounteredError: Error | undefined | null;
};

/**
 * Standard layout for the basic pages including the header and footer.
 */
export default class StandardLayout extends React.Component<Props, State> {
  static getDerivedStateFromError(err: Error) {
    return {
      encounteredError: err,
    };
  }

  componentDidCatch(err: Error) {
    errorReporter.notify(err);
  }

  state = {
    encounteredError: null,
  };

  render() {
    const { children, contentClassName, ...restProps } = this.props;
    const { encounteredError } = this.state;

    const className = cn('print:m-[2em]', contentClassName);

    return (
      <BaseLayout {...restProps}>
        {encounteredError == null ? (
          <>
            <AdminPanel />
            <SiteAnnouncements />
            <Notifications />
            <Header
              sessionInitFailedMessage={this.props.sessionInitFailedMessage}
            />
            <Modal />
            <div className={className}>{children}</div>
          </>
        ) : (
          <>
            <Header
              sessionInitFailedMessage={this.props.sessionInitFailedMessage}
            />
            <div className={className}>
              <Core.ContentWrapper>
                <RenderError error={encounteredError} />
              </Core.ContentWrapper>
            </div>
          </>
        )}
        <Footer />
      </BaseLayout>
    );
  }
}
